var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item-content',{staticClass:"h-16"},[_c('v-list-item-title',{staticClass:"font-weight-bold"},[_vm._v("現地支払")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }